export default __webpack_public_path__ + "home-background.6ec28cfefdd094e91c4d02322f67d618.jpg"